import { useEffect, useState } from 'react';
import { DropdownProps } from '@fluentui/react-northstar';
import { activeQuery, searchQueryProp } from './dropdownSearchQuery';

/**
 * Search text for a Northstar Dropdown that has to show a committed value's label while still
 * letting the user type. See dropdownSearchQuery.ts for why the prop is withheld mid-edit.
 */
export function useDropdownSearchQuery(committedLabel: string) {
  const [typedQuery, setTypedQuery] = useState<string>(null);

  const stopEditing = () => setTypedQuery(null);

  useEffect(() => {
    setTypedQuery(null);
  }, [committedLabel]);

  return {
    activeQuery: activeQuery(typedQuery, committedLabel),
    // committedLabel does not change when a commit is a no-op, so consumers reset explicitly
    stopEditing,
    searchQueryProps: {
      searchQuery: searchQueryProp(typedQuery, committedLabel),
      onSearchQueryChange: (_e, p: DropdownProps) => setTypedQuery(p.searchQuery ?? ''),
      onBlur: stopEditing
    }
  };
}
